import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@app/services';

@Pipe({
  name: '_date',
  pure: true,
})
export class DatePipe implements PipeTransform {
  constructor(private readonly translateService: TranslateService) {}

  public transform(value: any): any {
    if (!value) {
      return;
    }

    const config: any = this.translateService.getConfig;

    const options: any = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour12: false,
      timeZone: config.timeZone,
    };

    return new Intl.DateTimeFormat(config.locale, options).format(new Date(value));
  }
}
